import { useContext, useRef, useEffect } from 'react';
import { ContentContext, LabelContentContext, AdAuthContext, AdAuthContextProps } from './contexts';

export const useContent = () => useContext(ContentContext);
export const useLabels = () => useContext(LabelContentContext);
export const usePrevious = <T>(key: T): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = key;
  });
  return ref ? ref.current : undefined;
};
export const useAdAuth = (): AdAuthContextProps => useContext(AdAuthContext);
